import "core-js";
import 'jquery';
import axios from 'axios'
import resizilla from 'resizilla'
import leaders_swiper from './modules/leaders_swiper'
import timeline_swiper from './modules/timeline'
import news from './modules/news'
import storeMaps from './modules/store-maps'
import events from "./modules/events";
import modals from './modules/modals'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Paginate from 'vuejs-paginate'
import prekiu_zenklai_swiper from "./modules/prekiu_zenklai_swiper";
import '@fancyapps/fancybox'

Vue.use(VueRouter);
Vue.component('paginate', Paginate);

const router = new VueRouter({
  mode: 'history',
});

// Components
const files = require.context('./autoload-components', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.prototype.$http = axios;

Vue.mixin({
  data() {
    return {
      app: window.wp,
    }
  },
});

if (document.querySelectorAll('#app').length) {
  new Vue({
    router,
    el: '#app',
  });
}

$(document).ready(function () {

  const $hamburger = $('#hamburger');
  const $header_menu_wrap = $('.header-menu-wrap');

  // --------------------------------
  // Offset blocks
  // --------------------------------

  const $offset_block_toright = $('.offset-block--toright');
  const $offset_block_toleft = $('.offset-block--toleft');

  function push_block_toright() {
    $offset_block_toright.css({
      'width': `${window.innerWidth / 2}px`,
      'right': `-${window.innerWidth / 2}px`,
      'background-color': $offset_block_toright.closest('.relative').css('background-color'),
    });
  }

  function push_block_toleft() {
    $offset_block_toleft.css({
      'width': `${window.innerWidth / 2}px`,
      'left': `-${window.innerWidth / 2}px`,
      'background-color': $offset_block_toleft.closest('.relative').css('background-color'),
    });
  }

  push_block_toleft();
  push_block_toright();

  resizilla(() => {
    push_block_toleft();
    push_block_toright();
  }, 250, false, false, false);

  // end Offset blocks

  const $factory_more_info_trigger = $('.factory_more_info_trigger');

  $factory_more_info_trigger.on('click', function () {
    const $more = $(`#${$(this).data('more')}`);

    $more.slideToggle('fast');

    setTimeout(() => {
      $more.parent().toggleClass('mb-20')
    }, 140);
  });


  // --------------------------------
  // Karjera hidden recipietn field
  // --------------------------------

  const $recipient_email = $('#recipient_email');
  const $recipient = $('.recipient');

  if ($recipient_email.length) {
    $recipient.hide();
    $recipient.find('input[type="email"]').val($recipient_email.data('recipient-email'))
  }

  // end Karjera hidden recipient field


  // --------------------------------
  // Maps
  // --------------------------------

  document.querySelectorAll('.map-1-badget').forEach((elm) => {
    if (elm.classList.contains('opacity-100')) {
      document.getElementById('map_1_heading').innerHTML = elm.getAttribute('data-heading');
      document.getElementById('map_1_subheading').innerHTML = elm.getAttribute('data-subheading');
    }
  });

  function changeCountry(target_id) {
    const badget = document.getElementById(`badget_${target_id}`);
    document.querySelectorAll('[id^="badget_map_country_"]').forEach((elm) => elm.classList.remove('opacity-100'));
    badget.classList.add('opacity-100');

    const clicked_country_code = target_id.replace('map_country_', '');
    const countries_table = document.querySelectorAll('[id^="map_items_"]');
    const country = document.getElementById(`map_items_${clicked_country_code}`);
    const $catalog_link = $('#catalog_link');

    $catalog_link.attr('href', $catalog_link.data(`catalog${clicked_country_code}`));

    const [country_badget] = document.querySelectorAll(`.map-1-badget-${clicked_country_code}`);
    document.getElementById('map_1_heading').innerHTML = country_badget.getAttribute('data-heading');
    document.getElementById('map_1_subheading').innerHTML = country_badget.getAttribute('data-subheading');

    Array.from(countries_table).map((el) => {
      if (el.classList.contains('opacity-100')) {
        el.classList.add('opacity-0');
        el.classList.remove('opacity-100');
        el.classList.remove('top-0');
        el.classList.remove('left-0');
      }
    });

    if (country) {
      country.classList.remove('opacity-0');
      country.classList.add('opacity-100');
      country.classList.add('top-0');
      country.classList.add('left-0');
    }
  }

  if (document.querySelectorAll("[id^=map_country]").length) {
    let map = 0;
    for (let i = 1; i < 1000; i++) {
      setTimeout(function () {

        if (map === 4) {
          map = 0;
        }

        if (map === 0) {
          changeCountry(document.getElementById(document.querySelectorAll("[id^=map_country]")[0].getAttribute('id')).getAttribute('id'));
        }
        if (map === 1) {
          changeCountry(document.getElementById(document.querySelectorAll("[id^=map_country]")[2].getAttribute('id')).getAttribute('id'));
        }
        if (map === 2) {
          changeCountry(document.getElementById(document.querySelectorAll("[id^=map_country]")[3].getAttribute('id')).getAttribute('id'));
        }
        if (map === 3) {
          changeCountry(document.getElementById(document.querySelectorAll("[id^=map_country]")[1].getAttribute('id')).getAttribute('id'));
        }

        map++;

      }, i * 8000);
    }

    document.addEventListener('click', function (e) {
      if (e.target.id.startsWith('map_country')) {
        changeCountry(e.target.id);
      }
    });
  }

  // end Maps

  // --------------------------------
  // Swipers
  // --------------------------------
  new Swiper('.production-swiper', {
    slidesPerView: "auto",
    loop: false,
    spaceBetween: 0,
    breakpoints: {
      640: {
        slidesPerGroup: 1,
        centeredSlides: true,
        centeredSlidesBounds: true,
      },
    },
  });

  new Swiper('.blocks-3-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 0,
  });

  new Swiper('.front-swiper-container', {
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
  });

  new Swiper('.multirow-swiper', {
    slidesPerView: 3,
    slidesPerColumn: 3,
    spaceBetween: 15,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerGroup: 5,
        watchOverflow: true,
        slidesPerView: 5,
      },
    },
  });

  new Swiper('.swiper-new', {
    loop: true,
    slidesPerView: 5,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      300: {
        watchOverflow: true,
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      920: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 5,
      },
    },
  });

//Vertybes swipers

  new Swiper('.event-photos', {
    slidesPerView: 'auto',
    loop: true,
    spaceBetween: 86,
    centeredSlides: true,
    autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  new Swiper('.iniciation-photos', {
    slidesPerView: 4,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    autoHeight: true,
    navigation: false,
    pagination: {
      el: '.iniciation-swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 5,
        centeredSlides: false,
        autoHeight: false,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 10,
        centeredSlides: false,
        autoHeight: false,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  });

  new Swiper('.stories-photos', {
    slidesPerView: 'auto',
    loop: true,
    spaceBetween: 35,
    centeredSlides: true,
    autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-next-story',
      prevEl: '.swiper-button-prev-story',
    },
  });


  leaders_swiper.init();
  // resizilla( () => leaders_swiper.init(), 250, false, false, false );

  timeline_swiper.init();
  // resizilla( () => timeline_swiper.init(), 250, false, false, false );

  storeMaps.init();

  news.init();

  events.init();

  prekiu_zenklai_swiper.init();

  modals();

  if ($('.swiper-slide.gallery-3-items:not(.swiper-slide-duplicate) a, .swiper-slide.gallery-9-items:not(.swiper-slide-duplicate) a').length) {
    $().fancybox({
      selector: '.swiper-slide.gallery-3-items:not(.swiper-slide-duplicate) a, .swiper-slide.gallery-9-items:not(.swiper-slide-duplicate) a',
      buttons: [
        "close"
      ],
    });
  }

  $('.gallery-full').each(function () {
    new Swiper(this, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      effect: 'fade',
      watchOverflow: true,
      autoHeight: true,
      navigation: {
        nextEl: '.gallery-full-next',
        prevEl: '.gallery-full-prev',
      },
    })
  });

  $('.gallery-nice').each(function () {
    new Swiper(this, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      effect: 'fade',
      watchOverflow: true,
      autoHeight: true,
      navigation: {
        nextEl: '.gallery-nice-next',
        prevEl: '.gallery-nice-prev',
      },
    })
  });

  new Swiper('.news-swiper', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    spaceBetween: 16,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 'auto',
        autoHeight: false,
        longSwipes: false,
        grabCursor: false,
        threshold: 5000,
        shortSwipes: false,
        spaceBetween: 30,
      },
    },
  });

  // end Swipers

  $hamburger.on('click', function () {
    $(this).toggleClass('is-active');
    $header_menu_wrap.toggleClass('is_open');
  });

  $(".sub-trigger").on('click', function () {
    $(this).parent().toggleClass('hover');
  });

  $(document).ajaxComplete(function (event, xhr, settings) {
    if ($(".career-modal-inner").length) {
      if (JSON.parse(xhr.responseText).data) {
        if (JSON.parse(xhr.responseText).data.confirmation) {
          $("#event_registration_success").removeClass("hidden");
          $("#event_registration_outer").addClass("hidden");
        }
      }
    }
  });

  $('.career-contact').on('click', function () {
    $(".wpforms-field-checkbox.wpforms-list-2-columns input").prop("checked", false);
    $(".wpforms-field-checkbox.wpforms-list-2-columns").hide();
    $(".career-pos input").val($(this).attr("data-current") + " - " + $(".careet-single-content h1").text());
  });

  $('.show_contact_content_parent').on('click', function () {
    $(this).find(".show_contact_content").toggleClass('rotate-180');
    $(this).find('.content_to_show').slideToggle('fast');
  });

  $('.copy-url').on('click', function () {
    const copyText = $(this).attr('data-href');

    const textarea = document.createElement("textarea");
    textarea.textContent = copyText;
    textarea.style.position = "fixed";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");

    document.body.removeChild(textarea);
  });


  $.fn.isOnScreen = function (per) {

    const win = $(window);

    const viewport = {
      top: win.scrollTop(),
      left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height() * per;

    const bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));

  };

  function animItems() {
    $('.swiper-container,.flex-1 .container > *').each(function () {
      const cur = $(this);
      if (cur.isOnScreen(.8)) {
        if (!cur.hasClass("animated")) {
          cur.addClass("animated fadeInUp");

          setTimeout(() => {
            cur.addClass("opacity-1");
            cur.removeClass("fadeInUp");
          }, 850);
        }
      }
    });
  }

  animItems();
  $(window).on('scroll', function () {
    animItems()
  });
  $(window).on('resize', function () {
    animItems()
  });

// -----------------------------
// Read more answers FAQ
//
  $('.duk-row .question').click(function () {
    $(this).next().slideToggle();
    $(this).toggleClass('active');
  });


  function actionMoreLess(){
    var boxOuter = ".data_more_less",
      boxInner = ".data_more_less_inner",
      boxBody = ".data_more_less_body",
      showMore = $(".action-show-more"),
      showLess = $(".action-show-less");
    $(boxInner).each(function(){
      var $this = $(this),
        bodyDataH = $this.find(boxBody).height();
      $this.css("max-height", $this.data("height"));
      var $thisH = $this.height();
      if(bodyDataH > $thisH){
        $this.closest(boxOuter).removeClass("action_disabled");
      } else {
        $this.closest(boxOuter).addClass("action_disabled");
      }
    })
    showMore.click(function(e){
      e.preventDefault();
      var $this = $(this),
        boxInnerH = $this.closest(boxOuter).find(boxInner).height(),
        boxInnerUpdate = boxInnerH + $this.closest(boxOuter).find(boxInner).data("increase-by"),
        boxBodyH = $this.closest(boxOuter).find(boxBody).height();
      console.log(boxInnerH);
      setTimeout(function(){
        if(boxBodyH > boxInnerUpdate){
          $this.closest(boxOuter).removeClass("less_active").find(boxInner).css("max-height", boxInnerUpdate);
        } else {
          $this.closest(boxOuter).addClass("less_active").find(boxInner).css("max-height", "none");
        }
      },10);
    });
    showLess.click(function(){
      $(this).closest(boxOuter).removeClass("less_active").find(boxInner).css("max-height", $(this).closest(boxOuter).find(boxInner).data("height"));
      return false;
    });
  } actionMoreLess();


  $(document).on('click','.chained-quiz-choice',function() {
    $('.chained-quiz-choice').removeClass("on");
    $(this).addClass("on");
  });

});

$('#chained-quiz-action-2').val("Next Question");
$(document).ajaxSuccess(function() {
  $('#chained-quiz-action-2').val("Next Question");
});

// -----------------------------
// Sticky header
// -----------------------------

jQuery(window).scroll(function() {

  var scroll = $(window).scrollTop();
  if (scroll >= 10) {
    $('body').addClass('sticky-header');
  } else {
    $('body').removeClass('sticky-header');
  }
});

$('.toggle_more').on('click', function () {
  $(this).next('div').slideToggle('fast');
});

$(document).on('click', ".faq-trigger", function () {
  $(this).next().stop().slideToggle(300).parent().toggleClass("active");
  return false;
});

$(document).on('click', '.more .up', function() {
  $('html, body').stop().animate({
    scrollTop: 0
  }, 500);
  return false;
});

$('.play').fancybox();





// WEBPACK FOOTER //
// ./scripts/main.js